import { render, staticRenderFns } from "./ListPublications.vue?vue&type=template&id=07ccd3a2&scoped=true"
import script from "./ListPublications.vue?vue&type=script&lang=js"
export * from "./ListPublications.vue?vue&type=script&lang=js"
import style0 from "./ListPublications.vue?vue&type=style&index=0&id=07ccd3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ccd3a2",
  null
  
)

export default component.exports